/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import InquiryToCustomer from "../../../types/Entities/InquiryToCustomer";
import DownloadTile from "../../PetitionSummary/Documents/DownloadTile";
import { Stack } from "@mui/material";

type InquiryToCustomerMediaObjectsProps = {
  inquiryToCustomer: InquiryToCustomer;
};

export default function InquiryToCustomerMediaObjects({ inquiryToCustomer }: InquiryToCustomerMediaObjectsProps) {
  return (
    <>
      {inquiryToCustomer.mediaObjects?.length > 0 && (
        <Stack spacing={1}>
          {inquiryToCustomer.mediaObjects.map((mediaObject) => (
            <DownloadTile key={mediaObject.id} mediaObject={mediaObject} />
          ))}
        </Stack>
      )}
    </>
  );
}
